import React from 'react';

import {
  LoadingOverlay,
  LoadingOverlayProps,
  LoadingSpinner,
  LoadingSpinnerProps,
  LoadingText,
} from '@saas-ui/react';

interface LoadingScreenProps {
  variant?: LoadingOverlayProps['variant'];
  size?: LoadingSpinnerProps['size'];
  text?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  variant = 'fullscreen',
  size = 'xl',
  text = 'Loading...',
}) => {
  return (
    <LoadingOverlay variant={variant}>
      <LoadingSpinner size={size} />
      {text && <LoadingText>{text}</LoadingText>}
    </LoadingOverlay>
  );
};
